import { EMPTY_FIELD } from 'constants/emptyField';

import CheckIcon from '@mui/icons-material/Check';
import { useTheme } from '@mui/material/styles';
import { useRecordContext } from 'react-admin';
import { User } from 'types/embedded/user';

export const UsersListCorporateEmailField: React.FC = () => {
  const record = useRecordContext<User>();
  const theme = useTheme();

  return record && record?.corporateEmail ? (
    <CheckIcon fontSize="small" htmlColor={theme.palette.success.light} />
  ) : (
    EMPTY_FIELD
  );
};
